module.exports = __webpack_public_path__ + "static/media/18ECA50.02dae0a4.jpg";